// extracted by mini-css-extract-plugin
module.exports = {"plansContainer":"pricing-module--plansContainer--3_JAZ","faqContainer":"pricing-module--faqContainer--3s15Q","plansList":"pricing-module--plansList--3o9NG"};